import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Card } from 'primereact/card';
import { useTranslation } from 'react-i18next';
import TemplateEdit from '@app/pages/customer/TemplateEdit/TemplateEdit.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

const PageTemplateEdit = () => {
  const { t } = useTranslation('common');

  return (
    <ResponsiveLayout title={t(`RouteDetail.templateDetail`, `Detail trasy`)}>
      {/*
        // @ts-ignore*/}
      <Card>
        <TemplateEdit />
      </Card>
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(PageTemplateEdit);
